import LegacySidebarComponentAdapter from './LegacySidebarComponentAdapter';
import { getSidebarCard } from './customerDataSidebarCards';
import { useCallback } from 'react';
import devLogger from 'react-utils/devLogger';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function LegacySidebarCardTitleAdapter(props) {
  const {
    objectTypeId,
    cardType,
    title,
    isSidebarWrapperLoading
  } = props;
  const CardComponent = getSidebarCard(cardType);
  const TitleComponent = CardComponent && CardComponent.Title ? CardComponent.Title : undefined;
  const renderFallbackTitle = useCallback(() => /*#__PURE__*/_jsx(_Fragment, {
    children: title
  }), [title]);
  if (isSidebarWrapperLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: title
    });
  }
  if (TitleComponent && objectTypeId) {
    return /*#__PURE__*/_jsx(LegacySidebarComponentAdapter, Object.assign({
      CardComponent: TitleComponent,
      objectTypeId: objectTypeId,
      renderLoadingIndicator: renderFallbackTitle,
      renderErrorState: renderFallbackTitle
    }, props));
  }
  let errorCause = 'Unspecified Error Scenario';
  if (!CardComponent) {
    errorCause = `Missing CardComponent`;
  } else if (!TitleComponent) {
    errorCause = `Missing CardComponent.Title`;
  } else if (!objectTypeId) {
    errorCause = `Missing objectTypeId`;
  }
  const message = `Unable to load Legacy Card Title for ${cardType}. Cause: ${errorCause}`;
  if (!title) {
    throw new Error(message);
  }
  devLogger.warn({
    message: `${message}. Falling back to Card Definition Title`,
    key: `LegacySidebarCardTitleAdapter:${cardType}`
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: title
  });
}
export default LegacySidebarCardTitleAdapter;